export default __webpack_public_path__ + "static/media/rupis.5dc01711.svg";